import { GuideQuestFlow } from "./GuideQuestFlow.js";
import type { GameContext } from "./GameContext.js";
import type { RewardService } from "./commands/RewardService.js";
import type { ShellPorts } from "./commands/ports.js";
import type { RewardModalPresenter } from "../ui/RewardModalPresenter.js";

export interface CreateGuideQuestFlowDeps {
  readonly ctx: GameContext;
  readonly ports: ShellPorts;
  readonly rewards: RewardService;
  readonly rewardPresenter: RewardModalPresenter;
}

export function createGuideQuestFlow(deps: CreateGuideQuestFlowDeps): GuideQuestFlow {
  return new GuideQuestFlow({
    ctx: deps.ctx,
    ports: deps.ports,
    rewards: deps.rewards,
    openRewardModal: (reward, instances) => deps.rewardPresenter.open(reward, instances),
  });
}
